import { ApiResource } from '../api-resource';
import { Organization } from '../organization/organization.model';
import { Workshop } from '../workshop/workshop.model';
import { Camp } from '../camp/camp.model';
import {
  CoordinatesField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields';
import { Endpoint } from '../api.decorators';
import {
  CourseThemeSync,
  createSyncLocationFormGroup,
  Sync,
} from '../_lib/sync';

@Endpoint('locations', 'Location')
export class Location extends ApiResource<Location> {
  @StringField({ label: $localize`Name` })
  name!: string;

  @StringField({ label: $localize`Address` })
  address!: string;

  @StringField({ label: $localize`City` })
  city!: string;

  @StringField({ label: $localize`Postal code` })
  zipCode!: string;

  @StringField({ label: $localize`Country` })
  country!: string;

  @CoordinatesField()
  coordinates!: { type: 'POINT'; coordinates: [lng: number, lat: number] };

  @Field({
    includeFilter: false,
    formControlFactory: (fb) => createSyncLocationFormGroup(fb),
  })
  sync?: Sync<'uitPlace', CourseThemeSync>;

  @Field({ type: () => Camp, includeFilter: false })
  camps?: Camp[];

  @Field({
    type: () => Workshop,
    includeFilter: false,
  })
  workshops?: Workshop[];

  @Field({ label: $localize`Organization` })
  organization!: Organization;

  // Virtual columns
  totalCamps!: number;
  totalSeries!: number;
  totalWorkshops!: number;

  override toLabel(): string {
    return `${this.name} - ${this.city}`;
  }
}
